import { ActivatedRoute, RouterModule } from '@angular/router'
import { CRM_API_NEWSLEETER_SUBS_URL, CRM_API_NEWSLEETER_UNSUB_URL, CRM_API_TOKEN, NEWSLETTER_LIST } from '../../shared/constants'

import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { NewsletterSubsForm } from '../newsletter-subs-form/newsletter-subs-form'
import { timeout } from 'rxjs/operators'

@Component({
  selector: 'app-newsletter-unsubscription',
  imports: [
    FormsModule,
    RouterModule
],
  templateUrl: './newsletter-unsubscription.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './newsletter-unsubscription.component.scss'
})
export class NewsletterUnsubscriptionComponent implements OnInit {
  constructor(private http: HttpClient,
    private route: ActivatedRoute
  ) { }

  showForm: boolean = false

  email: string = ''
  form: NewsletterSubsForm = new NewsletterSubsForm()
  successMessage: string = ''
  token: string = CRM_API_TOKEN

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.email = params['email']
      console.log('Query parameter name:', this.email)
    })

    if (!this.email) {
      this.showForm = true
    } else {
      this.unsub(this.email)
    }
  }

  onSubmit() {
    this.unsub(this.email)
  }

  unsub(email: string) {
    const headers = new HttpHeaders({
      'Authorization': `Basic ${this.token}`,
      'Content-Type': 'application/json',
    })

    this.form.email = email
    this.form.listName = NEWSLETTER_LIST

    if (this.form.email != null && this.form.email.trim() != '') {
      this.http.post(CRM_API_NEWSLEETER_UNSUB_URL, this.form, { headers, observe: 'response' }).pipe(
        timeout(60000)
      ).subscribe({
        next: (response) => {
          console.log('Response:', response)
          this.successMessage = 'We are sorry to see you go. If you have any feedback or questions, please do not hesitate to contact us.'
          this.form = new NewsletterSubsForm()
        },
        error: (error) => {
          if (error.name === 'TimeoutError') {
            console.error('Error: Request timed out')
            this.successMessage = 'Unsubscription timed out. Please try again later.'
          } else {
            console.error('Error:', error)
            this.successMessage = 'Unsubscription failed. Please try again later.'
          }
        },
      })
    } else {
      this.successMessage = 'Please enter a valid email address'
    }
  }

  goBack() {
    window.history.back()
  }
}
